import React, { useEffect, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../AuthenticationProvider";
import { TFunction } from "i18next";
import { FullPageLoader } from "./FullPageLoader";

const getTextProps = (t: TFunction) => ({
    startingApp: t("Käynnistetään sovellusta"),
    wait: t("Odota"),
});

export const AuthInitializeGuard: React.FC = ({ children }) => {
    const { initialized, loggingIn, initialize } = useAuthContext();

    const skipInitialization = ["tulosta", "anonyymi", "anonyymilomake"].reduce(
        (acc, word) => (acc !== true ? window.location.pathname.indexOf(word) > -1 : acc),
        false,
    );

    useEffect(() => {
        if (!initialized && !skipInitialization && !loggingIn) {
            initialize();
        }
    }, [initialized, initialize, loggingIn, skipInitialization]);

    return initialized || skipInitialization ? <>{children}</> : <StillInitializing />;
};

const StillInitializing: React.FC = () => {
    const texts = getTextProps(useTranslation().t);

    return (
        <FullPageLoader loaderKey="StillInitializing" title={texts.startingApp} description={texts.wait} />
    );
    //  return (
    //     <LoaderSegment textAlign="center" padded="very" style={{ minHeight: "400px" }}>
    //         <Header as="h2">{texts.startingApp}</Header>
    //         <p><Icon name="circle notched" loading /> {texts.wait}</p>
    //      </LoaderSegment>
    //   );
};
